import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from "react";
import { useKeyboardInset, usePhone } from "../../lib/mobile";
import { Panels } from "../panels";
import { Sidebar } from "../sidebar";
import { Drawer } from "./drawer";

/**
 * Мобильная оболочка: одна выдвижная панель на всё, что не текущий список.
 *
 * На десктопе сайдбар и панели дня стоят по бокам постоянно — экрана хватает. На
 * телефоне хватает ровно на одно, и это одно — сам аутлайн. Всё остальное сведено
 * в ОДНУ панель слева: навигация сверху, сроки и повторяющиеся под ней. Две разные
 * шторки заставляли бы помнить, что в какой; одна — не заставляет.
 *
 * Ручка у панели одна и живёт в панели действий внизу, у большого пальца, а не в
 * верхнем углу, куда на телефоне не дотянуться.
 */
const ChromeContext = createContext<{ openMenu: () => void } | null>(null);

export function useMobileChrome() {
	const value = useContext(ChromeContext);
	if (value === null) {
		throw new Error("useMobileChrome вне MobileChrome");
	}
	return value;
}

export function MobileChrome({ children }: { children: ReactNode }) {
	const phone = usePhone();
	const [menu, setMenu] = useState(false);
	useKeyboardInset();

	const close = useCallback(() => setMenu(false), []);
	const value = useMemo(() => ({ openMenu: () => setMenu(true) }), []);

	return (
		<ChromeContext.Provider value={value}>
			{children}
			{phone && (
				<Drawer open={menu} side="left" title="Навигация" onClose={close}>
					<Sidebar drawer onNavigate={close} />
					<Panels drawer onNavigate={close} />
				</Drawer>
			)}
		</ChromeContext.Provider>
	);
}
